export default __webpack_public_path__ + "static/media/mobile-preview.82e3cb7d.gif";